module.exports = __webpack_public_path__ + "static/img/bottom_wxqy_n.3f39ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_wxqy_n.png
// module id = V9JK
// module chunks = 21